/* eslint-disable max-len */
import React from 'react';

const ProblemMonitor: React.FC<object> = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="8"
                cy="8"
                r="8"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM5.5547 9.16795L8 10.7981L10.4453 9.16795C10.9048 8.8616 11.5257 8.98577 11.832 9.4453C12.1384 9.90483 12.0142 10.5257 11.5547 10.832L8.5547 12.832C8.2188 13.056 7.7812 13.056 7.4453 12.832L4.4453 10.832C3.98577 10.5257 3.8616 9.90483 4.16795 9.4453C4.4743 8.98577 5.09517 8.8616 5.5547 9.16795ZM5.5547 4.16795L8 5.79815L10.4453 4.16795C10.9048 3.8616 11.5257 3.98577 11.832 4.4453C12.1384 4.90483 12.0142 5.5257 11.5547 5.83205L8.5547 7.83205C8.2188 8.05598 7.7812 8.05598 7.4453 7.83205L4.4453 5.83205C3.98577 5.5257 3.8616 4.90483 4.16795 4.4453C4.4743 3.98577 5.09517 3.8616 5.5547 4.16795Z"
                fill="#F44336"
            />
        </svg>
    );
};

export default ProblemMonitor;